@if (fetchedCategories$ | async; as categories) { @if (categories && categories.length && categories[0]) {
<div class="card-outer">
  <div class="category-card">
    <div class="card-image">
      @if (categories[0]?.images?.[0]?.effectiveUrl) {
      <img [src]="categories[0]?.images?.[0]?.effectiveUrl" alt="{{ categories[0]?.name }}" />
      } @if (!categories[0]?.images?.[0]?.effectiveUrl) {
      <img src="/assets/img/not-available.svg" alt="Image not found" />
      }
    </div>
    <div class="card-footer">
      @if (categories[0]?.uniqueId) {
      <a [routerLink]="['/category', categories[0]?.uniqueId]" class="footer-title-link">
        <span class="footer-title">{{ categories[0]?.name }}</span>
      </a>
      }
    </div>
    <div class="card-body">
      <div class="white-backdrop"></div>
      <div class="card-content">
        <ul class="subcategory-list">
          @for (child of categories.slice(1); track child; let i = $index) {
          <li [style.--index]="i">
            <a [routerLink]="['/category', child.uniqueId]" class="subcategory-link">
              <span class="arrow">▶</span> {{ child.name }}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
} }
